import * as Html from "../../util/Html.ts";
import * as CustomInput from "../../util/CustomInput.ts";
import * as modal from "../../util/modal.ts";
import * as i18n from "../../i18n.ts";
import * as rrule from "../../lib/rrule/rrule.js";
import * as rrulewriter from "../../lib/rrule/rrule-writer.js";
import * as DateUtils from "../../lib/DateUtils.ts";
import TPL from "../../modal/recurrency-custom.mustache";
import * as RRuleHelper from "../../lib/rrule/RRuleHelper.ts";

const RRule = rrule.RRule;
export {initDom}

Html.registerWidget('widget/form/recurrency',{initDom})

const DAYSOFWEEK = ["SU","MO","TU","WE","TH","FR","SA"];


function initDom(obj: HTMLElement){
  const originalForm = obj.closest('form') as HTMLFormElement;
  const startDateInput = originalForm.querySelector('[name="startDate"], [name="dueDate"]') as HTMLInputElement;
  const select = obj.querySelector('select') as HTMLSelectElement;
  let previousValue: string | undefined;
  const recurrencyInput = obj.querySelector('[name="recurrency"]') as HTMLInputElement;
  const intervalInput = obj.querySelector('[name="recurrencyInterval"]') as HTMLInputElement;
  const byDayInput = obj.querySelector('[name="byDay"]') as HTMLInputElement;
  const byMonthDayInput = obj.querySelector('[name="byMonthDay"]') as HTMLInputElement;

  function getStartDate(): Date | null {
    return CustomInput.getLocalDateValue(startDateInput);
  }

  function getCurrentDayOfWeek(): string | null {
    const startDate = getStartDate();
    if(!startDate) return null;
    return DAYSOFWEEK[startDate.getDay() % 7];
  }

  function getMonthPossibility(){
    const startDate = getStartDate();
    if (!startDate) return [];
    const weekdayIdx = startDate.getDay() - 1;
    const dayOfWeek = DAYSOFWEEK[(weekdayIdx + 1) % 7];
    const result = [{key:"", text: rrulewriter.write({simple:true, freq:1, bymonthday: startDate.getDate()})}];
    const month = startDate.getMonth();

    for(var i=1;i<5;i++){
      if(DateUtils.dateAdd(startDate,{day:-7*i}).getMonth()!==month){
        let
          byDay = i+dayOfWeek;
        result.push({key:byDay,text:rrulewriter.write({simple:true,freq:1,byweekday:[{n:i,weekday:weekdayIdx}]})});
        break;
      }
    }
    for(var i=1;i<2;i++){
      if(DateUtils.dateAdd(startDate,{day:7*i}).getMonth()!==month){
        let
          byDay = "-"+i+dayOfWeek;
        result.push({key:byDay,text:rrulewriter.write({simple:true,freq:1,byweekday:[{n:-i,weekday:weekdayIdx}]})});
        break;
      }
    }
    if(DateUtils.getRelativeDayToNextMonth(startDate)===-1){
        result.push({key:"-1",text:i18n.get('recurrency.lastofmonth')});
    }
    return result
  }

  startDateInput.addEventListener('change', function(){
    if(select.value === 'NONE' || select.value === 'CUSTOM') return;
    if(!CustomInput.getDateValue(startDateInput)){
      select.value = 'NONE';
      select.dispatchEvent(new Event('change'));
    }else{
      assignSimplifiedRrule(select.value);
    }
  });

  function assignSimplifiedRrule(input?: string){
    //we show or hide last of month
    const lastOfMonthOption = select.querySelector('option[value="FREQ=MONTHLY;BYMONTHDAY=-1"]') as HTMLOptionElement;
    const startDate = getStartDate();
    if(lastOfMonthOption) {
      if(startDate && DateUtils.getRelativeDayToNextMonth(startDate) === -1){
        lastOfMonthOption.style.display = '';
      }else{
        lastOfMonthOption.style.display = 'none';
      }
    }
    //we handle custom
    const simplifiedStr = RRuleHelper.simplify(input);
    const customOptions = select.querySelectorAll('option[data-custom]');
    customOptions.forEach(opt => opt.remove());

    //we verify if it is good and if not we fallback to simple recurrency
    const options = new RRuleHelper.RRuleOptions(simplifiedStr);
    const dateValue = CustomInput.getDateValue(startDateInput);
    if(!options.verify(dateValue)){
      select.value = 'FREQ=' + options.freq;
    }else if(select.querySelector(`option[value="${simplifiedStr}"]`)){
      select.value = simplifiedStr;
    }else{
      const newOption = document.createElement('option');
      newOption.value = simplifiedStr;
      newOption.selected = true;
      newOption.setAttribute('data-custom', 'true');
      newOption.textContent = rrulewriter.write(RRule.parseString(input));
      select.appendChild(newOption);
    }
    select.dispatchEvent(new Event('change'));
  }


  select.addEventListener('change', function(){
    const val = select.value;

    if(val !== 'NONE' && !CustomInput.getDateValue(startDateInput)){
      const now = new Date();
      now.setHours(now.getHours() + 1);
      now.setMinutes(now.getMinutes() - now.getMinutes() % 5);
      CustomInput.setDateValue(startDateInput, now);
    }

    if(val === 'CUSTOM'){
      select.value = previousValue || 'NONE';
      const startDayOfWeek = getCurrentDayOfWeek();
      const byDayMonth = byDayInput.value;
      const themodal = modal.openDomModal(TPL, {
        recurrencyInterval: Number(intervalInput.value) || 1,
        recurrency: recurrencyInput.value,
        byDay: byDayInput.value || startDayOfWeek,
        dayOfWeek: DateUtils.getWeekDays(),
        monthPossibility: getMonthPossibility()
      });
      const theForm = themodal.querySelector('form') as HTMLFormElement;
      const recurrencyInput2 = themodal.querySelector('[name="recurrency"]') as HTMLSelectElement;
      const intervalInput2 = themodal.querySelector('[name="recurrencyInterval"]') as HTMLInputElement;
      const recap = themodal.querySelector('.fw-recurrency') as HTMLElement;
      const weeklyNode = themodal.querySelector('.fw-recurrency-weekly') as HTMLElement;
      const weeklyByDayInput = weeklyNode.querySelector('[name="byDay"]') as HTMLInputElement;
      const monthlyNode = themodal.querySelector('.fw-recurrency-monthly') as HTMLElement;

      const byDayNodes = weeklyNode.querySelectorAll<HTMLElement>('[data-byday]');
      byDayNodes.forEach((node) => {
        const dayAttr = node.getAttribute("data-byday");
        if(dayAttr === startDayOfWeek){
          node.classList.add('fw-background-branded');
          node.classList.add('fw-locked');
        }else{
          node.style.cursor = 'pointer';
        }
        const selected = weeklyByDayInput.value.indexOf(dayAttr!) !== -1;
        node.classList.toggle("fw-background-branded", selected);
        node.classList.toggle("border-branded", selected);

        node.addEventListener('click', function(){
          const clickedDay = this.getAttribute("data-byday");
          if(clickedDay === startDayOfWeek){
            return;
          }
          this.classList.toggle('fw-background-branded');
          this.classList.toggle('border-branded');
          const selectedNodes = weeklyNode.querySelectorAll<HTMLElement>('[data-byday].fw-background-branded');
          const byDayVal = Array.from(selectedNodes).map(n => n.getAttribute("data-byday")).filter(Boolean);
          weeklyByDayInput.value = byDayVal.join(',');
          maj();
        });
      });
      const monthlyInputs = monthlyNode.querySelectorAll<HTMLInputElement>('input');
      monthlyInputs.forEach((radio) => {
        //console.log(radio.value,byDayMonth,radio.value==byDayMonth)
        // ==  is here on purpose
        if(radio.value == byDayMonth){
          radio.checked = true;
        }
      });

      function maj(){
        weeklyNode.style.display = recurrencyInput2.value === 'WEEKLY' ? '' : 'none';
        monthlyNode.style.display = recurrencyInput2.value === 'MONTHLY' ? '' : 'none';
        if(recurrencyInput2.value === 'MONTHLY'){
          recap.innerHTML = '';
        }else{
          const options = {
            freq: ['YEARLY','MONTHLY','WEEKLY','DAILY'].indexOf(recurrencyInput2.value),
            interval: intervalInput2.value,
            byweekday: weeklyByDayInput.value.split(',').map(item => {
              return {weekday: (DAYSOFWEEK.indexOf(item) + 6) % 7};
            })
          };
          recap.innerHTML = rrulewriter.write(options);
        }
      }

      recurrencyInput2.addEventListener('change', maj);
      intervalInput2.addEventListener('change', function(){
        let val = Number(this.value || 1);
        const max = Number(this.max);
        const min = Number(this.min);
        if(val > max){
          this.value = String(max);
        }else if(val < min){
          this.value = String(min);
        }
        maj();
      });

      const options2 = recurrencyInput2.querySelectorAll('option');
      options2.forEach((option) => {
        if(option.value === recurrencyInput.value){
          option.selected = true;
        }
      });
      maj();

      const okButton = themodal.querySelector('[data-button="ok"]') as HTMLElement;
      if (okButton) {
        okButton.addEventListener('click', function(evt){
          evt.preventDefault();
          let res = "FREQ=" + recurrencyInput2.value + ";INTERVAL=" + intervalInput2.value;
          if(recurrencyInput2.value === 'WEEKLY' && weeklyByDayInput.value){
            res += ";BYDAY=" + weeklyByDayInput.value;
          }
          if(recurrencyInput2.value === 'MONTHLY'){
            const value = (theForm as any).monthpossibility.value;
            if(value.match(/[A-Z]+/)){
              res += ";BYDAY=" + value;
            }else{
              res += ";BYMONTHDAY=" + value;
            }
          }
          assignSimplifiedRrule(res);
          modal.closeDomModal(themodal);
        });
      }

      const cancelButton = themodal.querySelector('[data-button="cancel"]') as HTMLElement;
      if (cancelButton) {
        cancelButton.addEventListener('click', function(evt){
          evt.preventDefault();
          modal.closeDomModal(themodal);
        });
      }
    }

    //maj others inputs
    if(val === 'NONE'){
      recurrencyInput.value = 'NONE';
      intervalInput.value = '1';
    }else if(val === 'CUSTOM'){
      recurrencyInput.value = 'NONE';
      intervalInput.value = '1';
    }else{
      const simplifiedOptions = RRuleHelper.asFamilywallForm(val);
      recurrencyInput.value = simplifiedOptions.recurrency;
      intervalInput.value = simplifiedOptions.recurrencyInterval;
      byDayInput.value = simplifiedOptions.byDay;
      byMonthDayInput.value = simplifiedOptions.byMonthDay;
    }
    previousValue = select.value;
  });

  assignSimplifiedRrule(select.getAttribute('rrule'));
  
}
